export class LoginWithOtpBindingModel{
    phoneNumber:string;
    captcha:string;
}